<template>
  <v-container>
    <v-row>
      <v-col cols="12">
        <span>Макет</span>
        <v-select
          outlined
          item-value="value"
          item-text="title"
          return-object
          hide-details
          dense
          :disabled="isLoading"
          :loading="isLoading"
          :value="listItem.data.layout"
          :items="$options.layoutsList"
          @change="mixChangeListItemHandler($event.value, 'layout')"
        />
      </v-col>
    </v-row>
    <v-row no-gutters>
      <v-divider />
    </v-row>
    <v-row no-gutters class="mt-5 mb-10">
      <v-col>
        <span>Список: ({{ listItem.data.images.length }})</span>
        <ErrorMessage :message="errorMessages.images" />
      </v-col>
      <v-spacer />
      <v-btn
        class="mr-2"
        small
        :disabled="isLoading"
        :loading="isLoading"
        @click="mixAddListItemItemHandler('images', $options.widgetItems)"
      >
        <v-icon small> mdi-plus </v-icon>
      </v-btn>
    </v-row>
    <v-row
      align="center"
      class="mb-5"
      v-for="(listItemItem, listItemItemIndex) in listItem.data.images"
      :key="listItemItemIndex"
    >
      <v-card max-width="100%" flat color="transparent">
        <v-card-title>
          <v-row align="center" justify="space-between">
            <span> Карточка {{ listItemItemIndex + 1 }}: </span>
            <v-btn
              class="mr-2"
              small
              :disabled="isLoading"
              :loading="isLoading"
              @click="mixRemoveListItemItemHandler(listItemItemIndex, 'images')"
            >
              <v-icon color="red">mdi-trash-can-outline</v-icon>
            </v-btn>
          </v-row>
        </v-card-title>
        <v-card-text>
          <v-row align="center">
            <v-col cols="6">
              <v-row no-gutters align="center">
                <MediaFilePicker
                  :multiple="false"
                  :label="'Медиа файл'"
                  :file-type="$options.mediaTypesByKeys.IMAGE"
                  :value="
                    listItemItem.data.image
                      ? listItemItem.data.image.id
                      : listItemItem.data.image
                  "
                  :isShowCaption="true"
                  :caption="listItemItem.data.caption"
                  @change="addImageHandler($event, listItemItemIndex)"
                  @change-caption="
                    mixChangeListItemItemHandler(
                      $event,
                      'images',
                      listItemItemIndex,
                      'caption'
                    )
                  "
                >
                  <template #preview-bottom>
                    <ErrorMessage
                      :message="
                        errorMessages[listItemItemIndex]
                          ? errorMessages[listItemItemIndex].image
                          : ''
                      "
                    />
                  </template>
                </MediaFilePicker>
              </v-row>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <span>Заголовок (<TranslationIcon />)</span>
              <v-text-field
                outlined
                :disabled="isLoading"
                :loading="isLoading"
                :value="listItemItem.data.title"
                @input="
                  mixChangeListItemItemHandler(
                    $event,
                    'images',
                    listItemItemIndex,
                    'title'
                  )
                "
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <span>Описание (<TranslationIcon />)</span>
              <v-textarea
                outlined
                :disabled="isLoading"
                :loading="isLoading"
                :value="listItemItem.data.description"
                @input="
                  mixChangeListItemItemHandler(
                    $event,
                    'images',
                    listItemItemIndex,
                    'description'
                  )
                "
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <span>Ссылка</span>
              <v-text-field
                outlined
                :disabled="isLoading"
                :loading="isLoading"
                :value="listItemItem.data.link"
                :error-messages="errorMessages[listItemItemIndex] ? errorMessages[listItemItemIndex].link : ''"
                @input="
                  mixChangeListItemItemHandler(
                    $event,
                    'images',
                    listItemItemIndex,
                    'link'
                  )
                "
              />
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-row>
  </v-container>
</template>

<script>
import dynamicListItemMix from '@/mixins/dynamic-list/dynamicListItem.mix.js'
import MediaFilePicker from '@/components/media-file-picker/MediaFilePicker.vue'
import { widgetItems } from '@/utils/widgets/widgetsTypes.js'
import ErrorMessage from '@/components/error-messages/ErrorMessage'
import TranslationIcon from '@/components/translation-icon/translationIcon'
import { mediaTypesByKeys } from '@/configs/mediaFileTypes'
import imageQuery from '@/services/gql/types/Files/queries/file.gql'

const layoutsList = [
  { title: '4 в ряд', value: 'four-in-row' },
  { title: '3 в ряд', value: 'three-in-row' },
  { title: '2 в ряд', value: 'two-in-row' }
]
export default {
  name: 'CardsSetWidget',
  mediaTypesByKeys: mediaTypesByKeys(),
  widgetItems,
  layoutsList,
  mixins: [dynamicListItemMix],
  data () {
    return {
      file: null,
      idImage: null,
      idx: null
    }
  },
  components: {
    TranslationIcon,
    ErrorMessage,
    MediaFilePicker
  },
  watch: {
    file (newImage) {
      this.mixUploadImageHandler(newImage, 'images', 'image', this.idx)
    }
  },
  methods: {
    async addImageHandler (event, idx) {
      this.idImage = event
      this.idx = idx
      await this.$apollo.queries.file.refetch()
    },
    prepareLayout (value) {
      switch (value) {
        case '3 в ряд':
          return '3-in-row'
        case '4 в ряд':
          return '4-in-row'
        case '  2 в ряд':
          return '2-in-row'
        default:
          return '2-in-row'
      }
    }
  },
  apollo: {
    file: {
      query: imageQuery,
      fetchPolicy: 'network-only',
      skip () {
        return !this.idImage
      },
      variables () {
        return {
          where: {
            id: this.idImage
          }
        }
      }
      // result (res) {
      //   this.image = res?.data?.file || null
      // }
    }
  }
}
</script>
